import React from 'react';
import { Button } from '../../../../../components';
import { t } from '../../../../../i18n';
import './styles.scss';

const PromoCodeInput = ({ value, error, isLoading, onChange, onBlur, onApplyPromocode }) => {
  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onApplyPromocode();
    }
  };

  return (
    <>
      <label htmlFor="promocode" className="courses-checkout-form__promocode-label">
        {t('DIGITAL_COURSES.CHECKOUT.PROMOCODE')}
      </label>
      <div className="courses-checkout-form__promocode-input-group">
        <div className="courses-checkout-form__promocode-text-field">
          <input
            id="promocode"
            name="promocode"
            type="text"
            placeholder={t('DIGITAL_COURSES.CHECKOUT.PROMOCODE')}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            autoComplete="off"
          />
          {error && <div className="error">{error}</div>}
        </div>
        <Button
          text={t('APPLY_PROMOCODE')}
          type="green"
          onClick={onApplyPromocode}
          className="courses-checkout-form__apply-button"
          disabled={!value || isLoading}
        />
      </div>
    </>
  );
};

export default PromoCodeInput;
